import { getKfzartId, getText } from '@/api/myTermine'
import {
	getCountries,
	getFinInformation,
	getUserVehicles,
	getVehicleBrandsModels,
	getVehicleCategories,
	getVehicleDrives,
	saveNewVehicle,
} from '@/api/myVehicles'

function defaultVehicleState() {
  return {
    userVehicles: null,
    selectedVehicle: null,
    initialRegistrationText: '',
    finInfo: [],
    newVehicle: null,
    rebookVehicle: null,
  }
}

export default {
  state: () => ({
    ...defaultVehicleState(),
    countries: [],
    vehicleBrandsModels: [],
    vehicleDrives: [],
    vehicleCategories: [],
  }),
  actions: {
    async getUserVehicles({ commit, dispatch }, cknr) {
      try {
        const response = await getUserVehicles(cknr)
        await commit('setUserVehicles', response.data)
        response.data.forEach((vehicle) => dispatch('getUserVehicleKfzartId', vehicle.vehicle))
      } catch (error) {
        console.error(error)
      }
    },
    async getUserVehicleKfzartId({ commit, state }, vehicle) {
      const params = {
        allrad: vehicle.fourWheelDrive || false, // in case of null
        antrieb: vehicle.antriebsart,
        udsKategorie: +vehicle.categoryKey,
      }

      try {
        const response = await getKfzartId(params)
        const index = state.userVehicles.findIndex((element) => element.vehicle.id === vehicle.id)
        commit('setUserVehiclesKfzartId', { index: index, kfzartId: response.data.id })
        commit('setUserVehiclesGebremst', { index: index, gebremst: response.data.gebremst })
      } catch (error) {
        console.error(error)
      }
    },
    async getNewVehicleKfzartId({ commit }, { fourWheelDrive, engine, categoryKey }) {
      const params = {
        allrad: fourWheelDrive,
        antrieb: engine,
        udsKategorie: categoryKey,
      }

      try {
        const response = await getKfzartId(params)
        commit('setNewVehicleKfzartId', { kfzartId: response.data.id })
        commit('setNewVehicleGebremst', { gebremst: response.data.gebremst })
      } catch (error) {
        console.error(error)
      }
    },
    async getInitialRegistrationText({ commit }) {
      try {
        const response = await getText(475)
        commit('setInitialRegistrationText', response.data.text)
      } catch (error) {
        console.error(error)
      }
    },
    async getDropdownLists({ dispatch }) {
      dispatch('getCountries')
      dispatch('getVehicleBrandsModels')
      dispatch('getVehicleDrives')
      dispatch('getVehicleCategories')
    },
    async getFinInformation({ commit }, fin) {
      try {
        const response = await getFinInformation(fin)
        commit('setFinInfo', response.data)
      } catch (error) {
        console.error(error)
      }
    },
    async getCountries({ commit }) {
      try {
        const response = await getCountries()
        commit('setCountries', response.data)
      } catch (error) {
        console.error(error)
      }
    },
    async getVehicleBrandsModels({ commit }) {
      try {
        const response = await getVehicleBrandsModels()
        commit('setVehicleBrandsModels', response.data)
      } catch (error) {
        console.error(error)
      }
    },
    async getVehicleDrives({ commit }) {
      try {
        const response = await getVehicleDrives()
        commit('setVehicleDrives', response.data)
      } catch (error) {
        console.error(error)
      }
    },
    async getVehicleCategories({ commit }) {
      try {
        const response = await getVehicleCategories()
        commit('setVehicleCategories', response.data)
      } catch (error) {
        console.error(error)
      }
    },
    async saveNewVehicle({ rootState }) {
      const newVehicle = rootState.vehicle.newVehicle

      const payload = {
        fourWheelDrive: newVehicle.fourWheelDrive,
        antriebsart: newVehicle.engine,
        category: newVehicle.category,
        categoryKey: newVehicle.categoryKey,
        brand: newVehicle.brand,
        brandDescription: newVehicle.brand.toLowerCase() === 'sonstige' ? 'Sonstige' : null,
        countryOfAdmission: newVehicle.country,
        erstzulassung: newVehicle.initialRegistration.split('.').reverse().join('-'),
        fin: newVehicle.fin,
        id: newVehicle.kfzartId,
        model: newVehicle.model,
        modelDescription: newVehicle.model.toLowerCase() === 'sonstige' ? 'Sonstige' : null,
        licensePlate: newVehicle.licensePlate,
        owner: {
          cknr: rootState.user.user.pnr,
          firstName: rootState.user.user.firstname,
          lastName: rootState.user.user.lastname,
        },
      }

      try {
        await saveNewVehicle(payload, rootState.user.user.pnr)
      } catch (error) {
        console.error(error)
      }
    },
  },
  mutations: {
    resetVehicleState(state) {
      Object.assign(state, {
        ...state,
        ...defaultVehicleState(),
      })
    },
    setUserVehicles(state, payload) {
      state.userVehicles = payload
    },
    setUserVehiclesKfzartId(state, payload) {
      state.userVehicles[payload.index].vehicle.kfzartId = payload.kfzartId
    },
    setUserVehiclesGebremst(state, payload) {
      state.userVehicles[payload.index].vehicle.gebremst = payload.gebremst
    },
    setSelectedVehicle(state, payload) {
      state.selectedVehicle = payload
    },
    setInitialRegistrationText(state, payload) {
      state.initialRegistrationText = payload
    },
    setFinInfo(state, payload) {
      state.finInfo = payload
    },
    setCountries(state, payload) {
      state.countries = payload
    },
    setVehicleBrandsModels(state, payload) {
      state.vehicleBrandsModels = payload
    },
    setVehicleDrives(state, payload) {
      state.vehicleDrives = payload
    },
    setVehicleCategories(state, payload) {
      state.vehicleCategories = payload
    },
    setNewVehicle(state, payload) {
      state.newVehicle = payload
    },
    setNewVehicleKfzartId(state, payload) {
      state.newVehicle.kfzartId = payload.kfzartId
    },
    setNewVehicleGebremst(state, payload) {
      state.newVehicle.gebremst = payload.gebremst
    },
    setRebookVehicle(state, payload) {
      state.rebookVehicle = payload
    },
  },
  getters: {
    userVehicles(state) {
      return state.userVehicles
    },
    selectedVehicle(state) {
      return state.selectedVehicle
    },
    initialRegistrationText(state) {
      return state.initialRegistrationText
    },
    finInfo(state) {
      return state.finInfo
    },
    countries(state) {
      return state.countries
    },
    vehicleBrandsModels(state) {
      return state.vehicleBrandsModels
    },
    vehicleDrives(state) {
      return state.vehicleDrives
    },
    vehicleCategories(state) {
      return state.vehicleCategories
    },
    newVehicle(state) {
      return state.newVehicle
    },
    rebookVehicle(state) {
      return state.rebookVehicle
    },
    kfzartId(state) {
      return state.selectedVehicle?.kfzartId || state.newVehicle?.kfzartId
    },
  },
}
